import { ArrowCircleUp, Delete, Edit, Forum } from "@mui/icons-material";
import moment from "moment";
import React from "react";
import { ThemeContext } from "../../../../../context/theme/ThemeContext";
import { authGetRequest } from "../../../../../api/laravel/public/api";
import Style from "./discussitem.module.scss";
import { _retrieveData } from "../../../../../utils/local-storage";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

function DiscussItem(props) {
  const { item, deleteComment, showComment } = props;
  const { theme, changeTheme } = React.useContext(ThemeContext);
  const [user, setUser] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(false);

  React.useEffect(() => {
    checkUser();
    // dashboardGet();
  }, []);

  const checkUser = async () => {
    let userData = await _retrieveData('user_info')
    if (!userData) {
    }
    else {
      setUser(userData);
    }
  }

  React.useEffect(() => {
    // getDiscussItem();
  }, [item.id]);

  const onDelete=(ev)=>{
    confirmAlert({
      title: 'Confirm to submit',
      message: 'Are you sure to delete this comment.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => deleteComment(ev)
        },
        {
          label: 'No',
          onClick: () => console.log('Click No')
        }
      ]
    });
  }

  const getDiscussItem = async () => {
    const { data_r, isError } = await authGetRequest(
      `/account/dashboard/discussions/view/${item.id}`
    );
    if (isError) {
      // errorMessage(toast, data_r?.message);
      setLoading(false);
      return false;
    }
    setData(data_r);
    setLoading(false);
  };
  return (
    <a onClick={() => showComment(item?.id)} className={Style.discuss_item}>
      <div className={Style.header_row}>
        {item?.created_by?.image &&
          <img
            width={30}
            src={
              process.env.REACT_APP_LOCAL_FILE_PATH +
              "profile/small/" +
              item?.created_by?.image
            }
            loading="lazy"
          />}
        {!item?.created_by?.image &&
          <div style={{ height: 40 }} className="btn btn-success rounded p-2">
            {item?.created_by?.first_name.charAt(0)}{item?.created_by?.last_name.charAt(0)}
          </div>
        }
        <div className={Style.col_dis}>
          <div className={Style.row_dis}>
            <span className={Style.a_attribute}>
              {item?.created_by?.first_name} {item?.created_by?.last_name}
            </span>
            {/* <b className={Style.a_attribute}>.Lecture 9.</b> */}
            <span>{moment(item?.created_at).fromNow()}</span>
          </div>
          <div style={{ color: theme === "light" ? "#000" : "#fff" }}>
            <span dangerouslySetInnerHTML={{ __html: item?.description }}></span>
          </div>

        </div>
        <div className={Style.col_up_dis}>
          <div className={Style.row_dis}>
            {user.id === item?.created_by?.id && (<button onClick={() => onDelete(item?.id)} className={Style.upvote}>
              <Delete />
            </button>)}
          </div>
          {/* <div className={Style.row_dis}>
            <button
             
              className={Style.upvote}
            >
              {item?.comments_more.length}
              <Forum />
            </button>
          </div> */}
        </div>
      </div>
      {/* <Comment item={item} key={index} /> */}
    </a>
  );
}

export default DiscussItem;
